import helper from '@/libs/forms';


const raceOptions = [
  { id: 'native', text: 'American Indian / Alaska Native' },
  { id: 'hawaiian', text: 'Hawaiian or Pacific Islander' },
  { id: 'asian', text: 'Asian' },
  { id: 'african', text: 'Black / African American' },
  { id: 'white', text: 'White' },
];

const hawaiianOptions = [
  { id: 'native_hawaiian', text: 'Native Hawaiian' },
  { id: 'guamanian_chamarro', text: 'Guamanian / Chamorro' },
  { id: 'samoan', text: 'Samoan' },
  { id: 'other', text: 'Other' },
];

const asianOptions = [
  { id: 'chinese', text: 'Chinese' },
  { id: 'filipino', text: 'Filipino' },
  { id: 'japanese', text: 'Japanese' },
  { id: 'korean', text: 'Korean' },
  { id: 'vietnamese', text: 'Vietnamese' },
  { id: 'indian', text: 'Asian Indian' },
  { id: 'other', text: 'Other' },
];


const getRaceFields = () => {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  const raceField = helper.multipleCheckbox('Race', 'races', raceOptions, true, 12,
    'bold-label', false);
  raceField.onChanged = (model, newVal) => {
    if (!newVal.includes('asian')) {
      model.asian = { heritage: null, description: null };
    }

    if (!newVal.includes('hawaiian')) {
      model.hawaiian = { heritage: null, description: null };
    }

    if (!newVal.includes('native')) {
      model.native = { tribe: null };
    }
  };


  const hawaiianHeritageField = helper.multipleCheckbox(
    'Specify Hawaiian/Pacific Islander Heritage', 'hawaiian.heritage', hawaiianOptions,
    true, 12, '', true, model => Array.isArray(model.races) && model.races.includes('hawaiian'),
  );
  hawaiianHeritageField.onChanged = (model, newVal) => {
    if (!newVal.includes('other')) {
      model.hawaiian.description = null;
    }
  };


  const asianHeritageField = helper.multipleCheckbox(
    'Specify Asian Heritage', 'asian.heritage', asianOptions,
    true, 12, '', true, model => Array.isArray(model.races) && model.races.includes('asian'),
  );
  asianHeritageField.onChanged = (model, newVal) => {
    if (!newVal.includes('other')) {
      model.asian.description = null;
    }
  };


  return [
    raceField,
    helper.simpleInput(
      'text', 'Specify Tribe', null, 'native.tribe', true, 12, null, model => (
        Array.isArray(model.races) && model.races.includes('native')
      ),
    ),
    hawaiianHeritageField,
    helper.simpleInput(
      'text', null, 'Describe', 'hawaiian.description', true, 12, null, model => (
        Array.isArray(model.hawaiian.heritage) && model.hawaiian.heritage.includes('other')
      ),
    ),
    asianHeritageField,
    helper.simpleInput(
      'text', null, 'Describe', 'asian.description', true, 12, null, model => (
        Array.isArray(model.asian.heritage) && model.asian.heritage.includes('other')
      ),
    ),
  ];
};


export default {
  schema: { fields: getRaceFields() },
  options: helper.options('demographics-race-', false),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/demographics/schemas/race.js